module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "welcomeViewModulesVue"
  }, _vm._l((_vm.componentsList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "news"
    }, [_c('div', {
      staticClass: "img"
    }, [_c('img', {
      staticStyle: {
        "width": "100%",
        "height": "100%",
        "border-radius": "9px"
      },
      attrs: {
        "src": item.noticeThumbnail,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "value"
    }, [_c('div', {
      staticClass: "head",
      staticStyle: {
        "-webkit-box-orient": "vertical"
      }
    }, [_vm._v(_vm._s(item.noticeTitle))]), _vm._v(" "), _c('div', {
      staticClass: "content",
      staticStyle: {
        "-webkit-box-orient": "vertical"
      }
    }, [_vm._v("\n                " + _vm._s(item.noticeContent) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "date"
    }, [_vm._v(_vm._s(_vm.$root.formatDate(item.noticeDate)))])])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75cb1a24"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/welcomeViewModules.vue
// module id = 1678
// module chunks = 471